import { Country, QuoteState } from '../types';
import { apiService } from './apiService';

/**
 * Generates the next sequential quote number via persistent backend.
 */
export const getNextQuoteNumber = async (country: Country): Promise<string> => {
  return await apiService.getNextQuoteNumber(country);
};

/**
 * Permanently archives the quote to the production database.
 */
export const finalizeAndSaveQuote = async (quote: QuoteState, country: Country, alias: string, id?: string): Promise<void> => {
  const success = await apiService.saveQuote(quote, country, alias, id);
  if (!success) {
      throw new Error("Failed to commit quote to production registry.");
  }
};